<template>
  <div class="allpage">
    <div class="btnBg" >
      <div class="box">
        <div class="nullbox"></div>
        <!-- <div class="xiazai" v-clipboard:copy="downLoadurl"  v-clipboard:success="onCopy"  v-clipboard:error="onError">下载</div> -->
        <div class="guanbi" @click="goPath"><img src="../../assets/guanbi.png">关闭</div>
      </div>
    </div>
    <canvas id="the-canvas" class="canvasstyle"/>    
    <div class="scalBox">
      <div class="da" @click="scalBig"><img src="../../assets/da.png"></div>
      <div class="xiao" @click="scalSmall"><img src="../../assets/xiao.png"></div>
    </div>
    <div class="btnBgDown">
      <div class="box">
        <div class="preNex" @click="prev"><img src="../../assets/zuo.png"></div>
        <div class="num">{{page_num}}/{{page_count}}</div>
        <div class="preNex" @click="next"><img src="../../assets/you.png"></div>
      </div>
    </div>
    <van-loading v-if="isload" type="spinner" color="#0094ff"/>
  </div>
</template>

<script>
  import PDFJS from 'pdfjs-dist'
  // import { Toast } from 'mint-ui';
  // let Base64 = require('js-base64').Base64
  export default {
    data () {
      return {
        title: '',
        pdfDoc: null,
        path:'/',
        downLoadurl: '',
        downloadFlag: '',
        pageNum: 1,//
        pageRendering: false,
        pageNumPending: null,
        scale: 1,// 放大倍数
        page_num: 0,// 当前页数
        page_count: 0,// 总页数
        maxscale: 0.2,// 最大放大倍数
        minscale: 1,// 最小放大倍数
        isload: true
      }
    },
    methods: {
      renderPage(num) { // 渲染pdf
        const vm = this
        this.pageRendering = true
        const canvas = document.getElementById('the-canvas')
        // Using promise to fetch the page
        this.pdfDoc.getPage(num).then(function(page) {
          let dpr = window.devicePixelRatio || 1
          let bsr = vm.ctx.webkitBackingStorePixelRatio ||
            vm.ctx.mozBackingStorePixelRatio ||
            vm.ctx.msBackingStorePixelRatio ||
            vm.ctx.oBackingStorePixelRatio ||
            vm.ctx.backingStorePixelRatio || 1
          let ratio = dpr / bsr
          var viewport = page.getViewport(screen.availWidth / page.getViewport(vm.scale).width)
          // alert(vm.canvas.height)
          canvas.height = viewport.height* ratio
          vm.pdfWidth = canvas.width = viewport.width* ratio          
          canvas.style.width = viewport.width + 'px'
          canvas.style.height = viewport.height + 'px'
          // Render PDF page into canvas context
           vm.ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
          var renderContext = {
            canvasContext: vm.ctx,
            viewport: viewport
          }
          var renderTask = page.render(renderContext)
          // Wait for rendering to finish
          renderTask.promise.then(function() {
            vm.pageRendering = false
            if (vm.pageNumPending !== null) {
            // New page rendering is pending
              vm.renderPage(vm.pageNumPending)
              vm.pageNumPending = null
            }
          })
        })
        vm.page_num = vm.pageNum
        vm.isload = false
      },
      loadFile () {
        let _this = this
        PDFJS.getDocument(this.downLoadurl).then(function(pdfDoc_) {
          _this.pdfDoc = pdfDoc_
          _this.page_count = _this.pdfDoc.numPages
          _this.$nextTick(() => {
            _this.renderPage(_this.pageNum)
          })
        })
      },
      queueRenderPage(num) {
        if (this.pageRendering) {
          this.pageNumPending = num
        } else {
          this.renderPage(num)
        }
      },
      scalBig() { // 放大
        if (this.scale <= this.maxscale) {
          return
        }
        this.scale -= 0.1
        this.queueRenderPage(this.pageNum)
      },
      scalSmall() { // 缩小
        if (this.scale >= this.minscale) {
          return
        }
        this.scale += 0.1
        this.queueRenderPage(this.pageNum)
      },
      prev() { // 上一页
        const vm = this
        if (vm.pageNum <= 1) {
          return
        }
        vm.pageNum--
        vm.queueRenderPage(vm.pageNum)
      },
      next() { // 下一页
        const vm = this
        if (vm.pageNum >= vm.page_count) {
          return
        }
        vm.pageNum++
        vm.queueRenderPage(vm.pageNum)
      },
      //返回
      goPath() {
        this.$router.push({
          path:this.path,
          query:{id:this.$route.query.id}
        })
      },
      onCopy(e) {
        Toast( '文件下载链接已复制到剪贴板，请打开浏览器下载！');
      },
      onError(e) {
          Toast('文件下载失败！');
      }
    },
    computed: {
      ctx() {
        const id = document.getElementById('the-canvas')
        return id.getContext('2d')
      }
    },
    mounted () {
      let url = this.$route.query.url;
      this.downLoadurl= url
      // this.downloadFlag= this.$route.query.downloadFlag
      this.loadFile();
    }
  }
</script>

<style scoped>
  .allpage{
    background: white;
    height: 100%;
  }
  .btnBg{
    position: fixed;
    top: 0;
    left: 0;
    background-color: white;
    width: 100%;
    height: 80px;
    z-index:999;
    padding: 10px 12px;
    box-sizing: border-box;
  }
  .btnBg .box{
    display: flex;
    justify-content: space-between;
  }
  .nullbox{
    width:80px;
  }
  .xiazai{
    width: 85px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #4073B8;
    border-radius: 4px;    
    font-size: 14px;
    color: #FFFFFF;
  }
  .guanbi{
    /* width: 80px; */
    padding: 0 16px;
    height: 48px;
    line-height: 48px;
    font-size: 28px;
    color: #FFFFFF;
    background: #B3B3B3;
  }
  .guanbi img{
    width: 20px;
    margin-right: 10px;
  }
  canvas {
    display: block;
    /* border: 1px dotted #666666; */
    position: absolute;
    top: 80px;
  }
  .scalBox{
    position: fixed;
    right: 20px;
    bottom: 160px;
  }
  .scalBox img{
    width: 80px;
  }
  .scalBox .xiao{
    margin-top: 20px;
  }
  .btnBgDown{
    position: fixed;
    bottom: 0;
    left: 0;
    /* background: white; */
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 160px;
  }
  .btnBgDown .box{
    display: flex;
    background: #2E2E33;
    align-items: center;
    color: #fff;
    font-size: 36px;
    height: 80px;
    border-radius: 15px;
  }
  .btnBgDown img{
    width: 26px;
  }
  .num{
    width: 150px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-left: 1px solid white;
    border-right: 1px solid white;
  }
  .preNex{
    width: 90px;
    text-align: center;
    height: 40px;
  }
  .van-loading {
    position: fixed;
    top: 45vh;
    left: 46vw;    
  }
</style>